// ============================================================
// casePermissions.ts — (Batch 4) the UI mirror of caseController.deleteCase:
// a case may be deleted by its assignee (fee-earner), an admin, or a member
// granted "Delete cases" (deleteCases). The server is the gate — this only
// hides Delete so nobody clicks into a 403. For a multi-selection, Delete
// shows only when EVERY selected case is deletable by the viewer.
// ============================================================
import type { AuthUser } from '../store/useCasevoStore'

export const canDeleteCases = (
  authUser: AuthUser | null | undefined,
  cases: { assignedToUserId?: string | null }[],
): boolean => {
  if (!authUser) return false
  if (authUser.role === 'admin' || authUser.effectivePermissions?.deleteCases) return true
  return cases.length > 0 && cases.every((c) => !!c.assignedToUserId && c.assignedToUserId === authUser.id)
}

// (Audit batch 3, H4) "Delete clients" — an admin, or a member granted it.
// The server is the gate (and keeps the notes / documents / cases safety
// rules); this only decides whether to OFFER the delete button.
export const canDeleteClients = (authUser: AuthUser | null | undefined): boolean =>
  !!authUser && (authUser.role === 'admin' || authUser.effectivePermissions?.deleteClients === true)
